import { isAuthentificated } from "@/services/auth";


function authGuardRoute(from, to, next) {
    if (isAuthentificated()) {
        next()
    } else {
        next(`/sign-in?from=${from.path}`)
    }
}

export { authGuardRoute }
